import React from 'react';
import { useNavigate } from "react-router-dom";

const Modal = ({ isOpen, onClose, children }) => {
  const navigate = useNavigate();
    
  const logOut = () => {
    localStorage.removeItem("username");
    navigate("/");
  };
  
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-10 flex items-center justify-center bg-black bg-opacity-50 ">
      <div className="bg-white p-4 shadow-md rounded-xl">
        {children}
        <div className='flex justify-end m-2'>
        <button className="p-2 mr-1 bg-red-500 rounded-lg text-white font-semibold" onClick={onClose}>
          Close
        </button>
        <button className="p-2 bg-green-600 rounded-lg text-white font-semibold" onClick={logOut}>
          Okay
        </button>
        </div>
      </div>
    </div>
  );
};

export default Modal;
